/* eslint-disable react/require-default-props */
import React from 'react';
import Api from 'services/api';
import { DocumentData } from 'store/modules/documents_store/types';

interface DocumentActionsButtonProps {
  document: DocumentData;
  setToBeDeletedDocumentId: React.Dispatch<React.SetStateAction<number | null>>;
  setDeleteDocumentModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
  handleEditDoc: (doc: DocumentData) => void;
  getDocumentId: (document: DocumentData) => number;
  setModalAuthenticateDocumentoOpened: React.Dispatch<React.SetStateAction<boolean>>;
  setCurrentDocumentId: React.Dispatch<React.SetStateAction<string>>;
  setShowModalWarningAdditional: React.Dispatch<React.SetStateAction<boolean>>;
  setDocumentSelectedForPreview: React.Dispatch<React.SetStateAction<DocumentData | null>>;
}

const DocumentActionsButton = (props: DocumentActionsButtonProps) => {
  const {
    document,
    handleEditDoc,
    getDocumentId,
    setToBeDeletedDocumentId,
    setDeleteDocumentModalOpened,
    setModalAuthenticateDocumentoOpened,
    setCurrentDocumentId,
    setShowModalWarningAdditional,
    setDocumentSelectedForPreview,
  } = props;

  const getDownloadDocuments = () => {
    Api.get(`/authenticated_documents/${document.authenticatedId}`, {}).then((response) => {
      if (response?.data?.url) {
        window.location.href = response?.data?.url;
      }
    });
  };

  return (
    <div className="btn-group" role="group">
      <button
        type="button"
        className="btn btn-sm btn-primary dropdown-toggle"
        data-toggle="dropdown"
        aria-expanded="false"
      >
        <span className="mr-1">Ações</span>
      </button>

      <div className="dropdown-menu dropdown-menu-right">
        {document?.fileUrl && (
          <button
            type="button"
            className="dropdown-item"
            key="btn-add-task"
            data-toggle="modal"
            data-target="#modal"
            onClick={() => {
              if (
                document?.default?.state === 'SP' &&
                document?.default?.documentName.includes('Falência')
              ) {
                setShowModalWarningAdditional(true);
                setDocumentSelectedForPreview(document);
              } else {
                window.open(document.fileUrl, '_blank');
              }
            }}
          >
            Ver documento
          </button>
        )}
        <button
          type="button"
          disabled={!(document.authenticationStatus === 'autenticado')}
          className="dropdown-item"
          key="btn-add-progress"
          data-toggle="modal"
          data-target="#modal"
          onClick={() => {
            getDownloadDocuments();
          }}
        >
          Ver autenticado
        </button>
        {document.is_aws !== undefined && (
          <button
            type="button"
            disabled={
              document.fileUrl.split('.')[document.fileUrl.split('.').length - 1] !== 'pdf' ||
              document.authenticationStatus === 'autenticado' ||
              document.authenticationStatus === 'pendente'
            }
            className="dropdown-item"
            key={`btn-remove-management-${document.id}`}
            onClick={() => {
              setModalAuthenticateDocumentoOpened(true);
              setCurrentDocumentId(document.id.toString());
            }}
          >
            Autenticar
          </button>
        )}
        {document?.is_aws && (
          <button
            type="button"
            className="dropdown-item"
            key={`btn-edit-bidding-${document.id}`}
            onClick={() => {
              handleEditDoc(document);
            }}
          >
            Editar
          </button>
        )}
        {document?.is_aws && (
          <button
            type="button"
            className="dropdown-item"
            key={`btn-finish-bidding-${document.id}`}
            onClick={() => {
              setToBeDeletedDocumentId(getDocumentId(document));
              setDeleteDocumentModalOpened(true);
            }}
          >
            Excluir
          </button>
        )}
      </div>
    </div>
  );
};

export default DocumentActionsButton;
